module.exports = __webpack_public_path__ + "static/media/smoking.1699626b.svg";